export default "__VITE_ASSET__BGayfYou__"